import { quizClosedTranslations } from './409/quizClosed.translation.en.ts';
import { quizExpiredTranslations } from './409/quizExpired.translation.en.ts';
import { quizFinishedTranslations } from './409/quizFinished.translation.en.ts';
import { quizToManyRevisitsTranslations } from './409/quizToManyRevisits.translation.en.ts';
import { personalDataTranslations } from './personalData/personalData.translation.en.ts';
import type { ProcessViewTranslation } from './processView.translations.pl.ts';
import { quizQuestionsTranslations } from './quizQuestions/quizQuestions.translation.en.ts';
import { quizScenariosTranslations } from './quizScenarios/quizScenarios.translation.en.ts';

export const processViewTranslations: ProcessViewTranslation = {
  quizQuestions: quizQuestionsTranslations,
  409: {
    ['409_1']: quizFinishedTranslations,
    ['409_2']: quizExpiredTranslations,
    ['409_3']: quizToManyRevisitsTranslations,
    ['409_closed']: quizClosedTranslations,
  },
  quizScenarios: quizScenariosTranslations,
  personalData: personalDataTranslations,
};
